import React, { useEffect, useState } from 'react'
import Lightbox from 'react-image-lightbox'
import { Image } from '../../../apis/response_types'
import { originalImageURL } from 'apis/attached_files'
import { IMAGE_OPTIMIZER } from './../../../constants'

interface ImagesPreviewProp {
  images: Array<Image>
  canClickable?: boolean
}
export const ImagesPreview = React.memo(
  ({ images, canClickable = false }: ImagesPreviewProp) => {
    const [openPreview, setOpenPreview] = useState(false)
    const [imageIndex, setImageIndex] = useState(0)
    const [imageLength, setImageLength] = useState(0)

    /**
     * サムネイル用のイメージURｌを生成して返す。
     * @param image
     * @param imageLength
     * @returns
     */
    const thumbnailImageURL = (image: Image, imageLength: number) => {
      const urlObject = new URL(image.url)

      const additionalQuery = `${
        imageLength > 1
          ? IMAGE_OPTIMIZER.size.thumbnails
          : IMAGE_OPTIMIZER.size.thumbnail
      }&optimize=medium`
      if (urlObject.search) {
        // クエリ文字列が既に存在する場合
        urlObject.search += `&${additionalQuery}`
      } else {
        // クエリ文字列が存在しない場合
        urlObject.search = `?${additionalQuery}`
      }

      if (image.token) urlObject.search += `&token=${image.token}`
      return urlObject.toString()
    }

    useEffect(() => {
      setImageLength(images.length)
    }, [images])

    return (
      <>
        {images.map((image: Image, index: number) => {
          if (!images) return <></>
          return (
            <React.Fragment key={image.id}>
              <div
                className="media"
                onClick={(e) => {
                  console.log(canClickable)
                  if (canClickable) {
                    setOpenPreview(true)
                  } else {
                    e.preventDefault()
                    e.stopPropagation()
                  }
                }}
                data-more={
                  imageLength >= 5 && index === 3 ? `+${imageLength - 4}` : ''
                }
              >
                <img
                  alt={`thumbnailImage-${images.length}`}
                  loading="lazy"
                  src={thumbnailImageURL(image, images.length)}
                />
              </div>
            </React.Fragment>
          )
        })}
        {canClickable && openPreview && (
          <div onClick={(e) => e.preventDefault()}>
            <Lightbox
              mainSrc={originalImageURL(images[imageIndex])}
              onCloseRequest={() => {
                setOpenPreview(false)
              }}
              imageTitle={`${imageIndex + 1}/${imageLength}`}
              prevSrc={originalImageURL(
                images[(imageIndex + imageLength - 1) % imageLength]
              )}
              nextSrc={originalImageURL(images[(imageIndex + 1) % imageLength])}
              onMovePrevRequest={() => {
                const index = (imageIndex - 1) % imageLength
                setImageIndex(index < 0 ? imageLength - 1 : index)
              }}
              onMoveNextRequest={() =>
                setImageIndex((imageIndex + 1) % imageLength)
              }
              wrapperClassName={imageLength === 1 ? 'prevNextButtonHidden' : ''}
            />
          </div>
        )}
      </>
    )
  }
)
